export default __webpack_public_path__ + "static/media/home.6c9bec2f.svg";